/**
 * @deprecated Use `useScreenOrientation` from `stores/smallStore` instead
 */
export const isLandscapeMode = () => {
  return window.matchMedia('(orientation: landscape)').matches
}
